module.exports = __webpack_public_path__ + "img/background.321089b4.jpeg";